import classNames from "classnames/bind";
import { isAnydayBrand } from "@~/utils/brands";
import styles from "./Brand.module.scss";

const cx = classNames.bind(styles);

export function Brand({
  brand,
  showLargeBrand,
}: {
  brand?: string;
  showLargeBrand?: boolean;
}) {
  const isAnyDayBrandedProduct = isAnydayBrand(brand);
  const isChanelBrandedProduct = brand === "CHANEL";

  return (
    <span
      className={cx("title__brand", {
        title__brand__chanel: isChanelBrandedProduct,
        title__brand__large: showLargeBrand,
      })}
    >
      {isAnyDayBrandedProduct && (
        <span className={styles.title__brandPrefix}>John Lewis</span>
      )}{" "}
      {isAnyDayBrandedProduct ? "Anyday" : brand}
    </span>
  );
}
